import { render, staticRenderFns } from "./StatDashboard.vue?vue&type=template&id=8acdf872&scoped=true&"
import script from "./StatDashboard.vue?vue&type=script&lang=js&"
export * from "./StatDashboard.vue?vue&type=script&lang=js&"
import style0 from "./StatDashboard.vue?vue&type=style&index=0&id=8acdf872&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8acdf872",
  null
  
)

export default component.exports